module.exports = __webpack_public_path__ + "static/img/have_icon.776d367d.png";